<script>
    import axios from 'axios'
    import {Listeners} from "../../../../../constants/listeners";
    import {store} from "../../../store";

    export default {
        data () {
            return {
                targetNode: -2,
                store: store,
            }
        },
        methods: {
            emptyTrash(){
                let self = this;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                })
                    .then(function () {
                        setTimeout(() => {
                            self.$emitter.emit(Listeners.CLUSTER_TREE_RELOAD);
                        }, 500);
                        self.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                    })
            },
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getApiUrl(){
                return this.$config.API_URL + '/clustering/node/' + this.getUid + '/empty_trash';
            },
        },
        mounted() {
            this.$emitter.on(Listeners.CLUSTER_EMPTY_TRASH, () => {
                this.emptyTrash()
            });
        },
    }
</script>
<template>
</template>
